import { clientApi } from "../interceptor/_clientInstance";

export const mobileOTP = async (data: { mobile: string }) => {
  return await clientApi.post(`/c/auth/otp/`, data);
};

export const verifyOTP = async (data: { mobile: string; otp: string }) => {
  return await clientApi.post(`/c/auth/verify/`, data);
};

export const emailOTP = async () => {
  return await clientApi.get(`/c/auth/resend-email-otp/`);
};

export const verifyEmailOTP = async (data: { otp: string }) => {
  return await clientApi.post(`/c/auth/verify-email/`, data);
};

export const postQuestion = async (data: FormData) => {
  // Backend route is `c/site/question` (no trailing slash).
  const response = await clientApi.post(`/c/site/question`, data);
  return response.data;
};

// to search exisiting blogs
export async function searchBlogList(searchValue: any) {
  try {
    const params = new URLSearchParams();
    params.set("s", searchValue.toString());
    const response = await clientApi.get("/c/blog/post", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching searched blogs:", error);
    throw error;
  }
}
